import React from 'react';

const DescriptionField = ({
  // autofocus,
  description,
  // disabled,
  // errorSchema,
  // formContext,
  // formData,
  id,
  // idSchema,
  // name,
  // onChange,
  // readonly,
  // registry,
  // required,
  // schema,
  // uiSchema,
}) => <span id={id}>{description}</span>;

export default DescriptionField;
